module.exports = __webpack_public_path__ + "static/media/BovExo_template_pesagens_medicoes.7323df0e.xlsx";